import * as React from 'react';
import { connect } from 'react-redux';

import { createUser, getOrgUsers, getUserById } from '../../actions/users';

import UserCreateFormOverlay from '../../components/users/UserCreateFormOverlay';
import Loader from '~/common/components/Loader';
import { getOrgLocations } from '~/apps/shared/actions/locations';


class UserCreatePopup extends React.Component<any, any> {
  componentDidMount() {
    const { dispatch, orgId } = this.props;
    dispatch(getOrgLocations(orgId));
  }

  onSubmit = (data) => {
    const { dispatch, orgId, } = this.props;
    const req = {
      ...data,
      locationId: !data.locationId ? '' : data.locationId,
      //   organizationId: orgId,
    };

    return dispatch(createUser(req))
      .then(() => {
        // TODO: Use refresh
        dispatch(getOrgUsers());
        this.props.onReturn();
      });
  };

  onClose = () => {
    this.props.onReturn();
  };

  locationOptions = () => {
    const { locations: { entities, ui: { currentList } } } = this.props;

    return [{
      label: '- Without Location -',
      value: null,
    }].concat(currentList.map((id) => (
      {
        label: entities[id].name,
        value: id,
      }
    )))
  };


  render() {
    const { errorMessage, loading } = this.props;

    if (loading) {
      // TODO:
      return (
        <Loader className="load--ol"/>
      );
    }

    return (
      <UserCreateFormOverlay
        headTitle="New User"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        errorMessage={errorMessage}
        locations={this.locationOptions()}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.shared.locations,
    errorMessage: state.shared.users.ui.errorMessage,
    loading: state.shared.users.ui.loading,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCreatePopup) as any;
